module.exports = __webpack_public_path__ + "img/video-cover-typeface.5efd8dc6.jpg";